import { ITimeTrackerState } from './types';
import { getTimeTrackerLocalStorage } from './localStorage/actions/getTimeTrackerLocalStorage';

const initialTimeTracker: ITimeTrackerState = null;

export const getInitialTimeTracker = (): ITimeTrackerState => {
    return {...initialTimeTracker, ...getTimeTrackerLocalStorage()};
};
